import { mobile } from "../../../mediaQueries"

const styles = theme => ({
    wrapper: {
        position: 'absolute',
        top: props => props.y,
        left: props => props.x,
        zIndex: 30
    },
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.2)',
        flexDirection: 'column',
        padding: '1rem',
        minWidth: '250px',
        backgroundColor: 'white',
        maxWidth: '300px'
    },
    point: {
        width: '60px',
        height: '60px',
        position: 'absolute',
        left: props => `${props.x}`,
        top: props => `${props.y}`,
        cursor: 'pointer',
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            height: '50px',
            width: '50px'
        }
    },
    cover: {
        width: '100%',
        height: '100%'
    },
    closeIcon: {
        margin: '0 0 1rem 0',
        borderRadius: '50%',
        alignSelf: 'flex-start',
        padding: 0,
        cursor: 'pointer',
        width: '28px',
        height: '28px',
        color: '#575452'
    },
    content: {
        color: '#575452',
        fontFamily: 'Aktiv Grotesk',
        margin: '0.5rem 0 0 0',
        fontSize: '14px',
        lineHeight: '21px',
        letterSpacing: '0.02em'
    },
    title: {
        color: '#575452',
        fontFamily: 'Aktiv Grotesk Bold',
        margin: '1rem 0 0 0',
        fontSize: '14px',
        lineHeight: '21px',
        letterSpacing: '0.02em',
        display: 'inline-block',
        width: '100%',
        textAlign: 'left'
    }
})

export default styles